export const getCustomSelectValue = (id) =>
  document.getElementById(id)?.getAttribute("data-value") ?? "";

export const getCustomSelectLabel = (id) =>
  document.getElementById(id)?.getAttribute("data-selected-label") ?? "";

export const getCustomSelectFieldWrap = (id) =>
  document.getElementById(id)?.closest(".t-icInput, .t-resetPassword-inputWrap, .t-inputLogin, .t-appCustomSelectField");

export const getCustomSelectStatusElement = (id) => {
  const trigger = document.getElementById(id);
  return trigger?.closest(".t-eminPayCustomSelect")?.nextElementSibling ?? null;
};

export const setCustomSelectFieldState = (id, hasError) => {
  const wrap = getCustomSelectFieldWrap(id);
  const statusElement = getCustomSelectStatusElement(id);

  if (!wrap) {
    return;
  }

  if (hasError) {
    wrap.classList.add("t-error");
    if (statusElement) {
      statusElement.innerHTML = "<i class='t-icon-error text-danger'></i>";
    }
    return;
  }

  wrap.classList.remove("t-error");
  if (statusElement) {
    statusElement.innerHTML = "<i class='t-icon-check_circle_outline text-success'></i>";
  }
};
